<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button
              @click="createColor()"
              class="bg_l_green"
              v-has-permission="permission138"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewColor") }}
            </vs-button>
          </div>
        </div>
        <modify-popup
          :show="ModifyPopup"
          :model="modalModel"
          @finish="onfinish"
          @close="closeModifyPopup"
        ></modify-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Title'), sort: 'Name' },
                { title: $t('ColorCode'), sort: 'Code' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 25%">
                  {{ row.name }}
                </td>
                <td style="width: 25%; direction: ltr">
                  {{ row.id }}
                </td>
                <td style="direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 25%">
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="editColor(row)"
                    class="ml-4 d-inline"
                    v-has-permission="permission139"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteColor(row.id)"
                    class="d-inline"
                    v-has-permission="permission140"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./CreateAndModifyPopup.vue";

export default {
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      permission138: "CreateProductColor",
      permission139: "ModifyProductColor",
      permission140: "DeleteProductColor",
      ModifyPopup: false,
      modalModel: {},
      itemList: [],
      gridDataSource: {
        type: "app",
        service: "ProductManagement/api/ProductColorsQuery",
      },
      gridSearchData: {},
    };
  },
  methods: {
    ...mapActions({
      removeColors: "color/remove",
    }),
    ////Open Modal In Create Mode
    createColor() {
      this.modalModel = {};
      this.ModifyPopup = true;
      this.modalModel.code = "";
    },
    //Open Modal In Edit Mode
    editColor(model) {
      this.modalModel = {
        id: model.id,
        code: model.code,
        name: model.name,
        isActive: model.isActive,
      };
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteColor(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeColors(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
